/**
 * 角色管理实体
 */

import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '角色';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [rolename, setRolename] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setIsModalOpen(false);
        setLoading(false);
        setRolename('');
        setDisplayname('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setRolename(props.record.rolename);
            setDisplayname(props.record.displayname);
            setDescription(props.record.description);
        }
    }, [props.record]);

    const ok = () => {
        //  参数校验
        var rex = CNF.regex.rolename.exec(rolename)
        if (rex == null || rex[0] !== rolename) {
            messageApi.error('角色名格式错误！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'roles' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'rolename': rolename,
                'displayname': displayname,
                'description': description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, 1500);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={400}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.isModalOpen}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}角色名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setRolename(e.target.value)}
                            value={rolename}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}显示名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setDisplayname(e.target.value)}
                            value={displayname}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='角色描述可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}
export default Entity